import React from 'react';
import HidePriceDateList from './HidePriceDateList';

function HidePriceDateTab() {
    return <HidePriceDateList />;
}

export default React.memo(HidePriceDateTab);
